<template>
    <div class="privacy">
        <div class="privacy-cont">
            <div class="privacy-section">
                <div class="privacy-section-container">
                    <div class="privacy-section-container-title" v-if="!loading && privacyPolicyList?.[0]">
                        <h1><strong>{{ privacyPolicyList[0].title }}</strong></h1>
                    </div>
                    <!-- 加载中占位符 -->
                    <div v-if="loading" class="loading-placeholder">
                        <div class="skeleton-title"></div>
                        <div class="skeleton-content" v-for="i in 5" :key="i">
                            <div class="skeleton-subtitle"></div>
                            <div class="skeleton-text"></div>
                            <div class="skeleton-text"></div>
                            <div class="skeleton-text"></div>
                        </div>
                    </div>
                    <div class="privacy-section-container-body" v-if="!loading && privacyPolicyList">
                        <div v-for="(item, index) in privacyPolicyList.slice(1)" :key="index">
                            <h2><strong>{{ item.title }}</strong></h2>
                            <div v-html="item.content"></div>
                        </div>

                    </div>
                    <!-- <div class="privacy-section-container-body">
                        <h2><strong>KOMO WELLNESS BUSINESS PTE. LTD. Privacy Policy</strong></h2>
                        <p>Last updated: Oct 29, 2025</p>
                        <p>This <strong>Privacy Policy</strong> describes how <strong>KOMO WELLNESS BUSINESS PTE.
                                LTD.</strong> (the "<strong>Site</strong>", "<strong>we</strong>",
                            "<strong>us</strong>",
                            or "<strong>our</strong>") collects, uses, and discloses your personal information when you
                            visit, use our
                            services, or make a purchase from <a
                                href="https://www.komowellness.com/">www.komowellness.com</a>
                            (the
                            "<strong>Site</strong>") or otherwise communicate
                            with us (collectively, the "<strong>Services</strong>"). For purposes of this Privacy
                            Policy, "<strong>you</strong>" and
                            "<strong>your</strong>" means you as the user of the Services, whether you are a customer,
                            website visitor,
                            or another individual whose information we have collected pursuant to this Privacy Policy.
                        </p>
                        <p>Please read this Privacy Policy carefully. <strong>By using and accessing any of the
                                Services, you
                                agree</strong> to the collection, use, and disclosure of your information as described
                            in this
                            Privacy Policy. <strong>If you do not agree to this Privacy Policy, please do not use or
                                access any
                                of the Services.</strong></p>

                        <h2><strong>Changes to This Privacy Policy</strong></h2>
                        <p>We may update this Privacy Policy from time to time, including to reflect changes to our
                            practices or for other operational, legal, or regulatory reasons. <strong>We will post the
                                revised
                                Privacy Policy on the Site</strong>, update the "Last updated" date and take any other
                            steps required
                            by applicable law.</p>

                        <h2><strong>How We Collect and Use Your Personal Information</strong></h2>
                        <p>To provide the Services, we collect and have collected over the past 12 months personal
                            information about you from a variety of sources, as set out below. The information that we
                            collect and use varies depending on how you interact with us.</p>
                        <p>In addition to the specific uses set out below, <strong>we may use information we collect
                                about you
                                to communicate with you, provide the Services, comply with any applicable legal
                                obligations,
                                enforce any applicable terms of service, and to protect or defend the Services, our
                                rights,
                                and the rights of our users or others.</strong></p>
                        <h2><strong>What Personal Information We Collect</strong></h2>
                        <p>The types of personal information we obtain about you depends on how you interact with our
                            Site and use our Services. When we use the term "<strong>personal information</strong>", we
                            are referring to
                            information that identifies, relates to, describes or can be associated with you.</p>

                        <h2><strong>Information We Collect Directly from You</strong></h2>
                        <p>Information that you directly submit to us through our Services may include:</p>
                        <ul>
                            <li>
                                <strong>Contact details</strong> including your name, address, billing address, shipping
                                address, phone number, and email address.
                            </li>
                            <li>
                                <strong>Basic contact details</strong> ncluding your name, address, phone number, email.
                            </li>
                            <li>
                                <strong>Order information</strong> including your name, billing address, shipping
                                address, payment confirmation, email address, phone number.
                            </li>
                            <li>
                                <strong>Account information</strong> including your username, password, security
                                questions.
                            </li>
                            <li>
                                <strong>Shopping information</strong> including the items you view, put in your cart or
                                add to your wishlist.
                            </li>
                            <li>
                                <strong>Customer support information</strong> including the information you choose to
                                include in communications with us, for example, when sending a message through the
                                Services.
                            </li>
                            <li>
                                Some features of the services may require you to directly provide us with certain
                                information about yourself. You may elect not to provide this information, but doing so
                                may prevent you from using or accessing these features.
                            </li>
                        </ul>

                        <h2><strong>Information We Collect through Cookies</strong></h2>
                        <p>We also automatically collect certain information about your interaction with the Services
                            ("<strong>Usage Data</strong>"). To do this, we may use <strong>cookies, pixels and similar
                                technologies ("Cookies")</strong>.
                            Usage Data may include information about how you access and use our Site and your account,
                            including device information, browser information, information about your network
                            connection, your IP address and other information regarding your interaction with the
                            Services.</p>

                        <h2><strong>Information We Obtain from Third Parties</strong></h2>
                        <p>Finally, we may obtain information about you from <strong>third parties</strong>, including
                            from vendors and
                            service providers who may collect information on our behalf, such as:</p>
                        <ul>
                            <li>
                                Companies who support our Site and Services.
                            </li>
                            <li>
                                Our <strong>payment processors,</strong>who collect payment information (e.g., bank
                                account, credit or debit card information, billing address) to process your payment in
                                order to fulfill your orders and provide you with products or services you have
                                requested.
                            </li>
                            <li>
                                When you visit our Site, open or click on emails we send you, or interact with our
                                Services or advertisements, we or third parties we work with may automatically collect
                                certain information using <strong>online tracking technologies</strong>such as pixels,
                                web beacons, SDKs, third-party libraries, and cookies.
                            </li>
                        </ul>
                        <p>Any information we obtain from third parties will be <strong>treated in accordance with this
                                Privacy Policy.</strong> We are <strong>not responsible or liable</strong> for the
                            accuracy of the information provided to us by third parties and are not responsible for any
                            third party's policies or practices.</p>
                        <p>For more information, see the section below, <strong>Third Party Websites and Links</strong>.
                        </p>

                        <h2><strong>How We Use Your Personal Information</strong></h2>
                        <ul>
                            <li>
                                <strong>Providing Products and Services</strong> — to process your payments, fulfill
                                your orders, manage your account, arrange shipping, facilitate returns, and enable
                                product reviews.
                            </li>
                            <li>
                                <strong>Marketing and Advertising</strong> — to send marketing communications and show
                                you relevant advertisements across our Site and other platforms.
                            </li>
                            <li>
                                <strong>Security and Fraud Prevention</strong> — to detect, investigate or act on
                                possible fraudulent or illegal activity.
                            </li>
                            <li>
                                <strong>Communicating with You</strong> — to provide customer support and improve our
                                Services.
                            </li>
                        </ul>
                        <h2><strong>Cookies</strong></h2>
                        <p>Like many websites, <strong>we use cookies</strong> on our site. We use Cookies to power and
                            improve our Site and our Services (including to remember your actions and preferences), to
                            run analytics, and to understand user interactions.</p>
                        <p>You can choose to remove or reject cookies through your browser controls. However,
                            <strong>blocking Cookies may affect your user experience or functionality</strong> of the
                            services.
                        </p>

                        <h2><strong>How We Disclose Personal Information</strong></h2>
                        <p>In certain circumstances, we may disclose your personal information to third parties for
                            legitimate purposes subject to this Privacy Policy. Such circumstances may include:</p>
                        <ul>
                            <li><strong>With vendors or service providers</strong> (e.g., IT management, payment
                                processing, data analytics, customer support, shipping).</li>
                            <li><strong>With business and marketing partners</strong>, to provide services and advertise
                                to you.</li>
                            <li><strong>With affiliates</strong>, within our corporate group.</li>
                            <li><strong>In connection with business transactions</strong> such as mergers or
                                bankruptcies, or to comply with legal obligations.</li>
                        </ul>
                        <p>We have, in the past 12 months, disclosed the following categories of personal information:
                        </p>
                        <ul>
                            <li><strong>Identifiers </strong>(name, contact details, account information)</li>
                            <li><strong>Commercial information </strong>(order and shopping data)</li>
                            <li><strong>Internet or network activity</strong> (usage data)</li>
                        </ul>
                        <p>We do <strong>not use or disclose sensitive personal information</strong> for the purpose of
                            inferring characteristics about you.</p>
                        <p>We have <strong>“sold” or “shared”</strong> certain categories of information (as defined
                            under applicable law) for advertising and marketing activities.</p>

                        <h2><strong>User Generated Content</strong></h2>
                        <p>The Services may enable you to post reviews or other content. <strong>Please note that any
                                information you post will be public and accessible by anyone</strong>.</p>
                        <p>We are <strong>not responsible for any privacy or security</strong> issues related to
                            publicly shared information.</p>

                        <h2><strong>Third Party Websites and Links</strong></h2>
                        <p>Our Site may provide links to <strong>third-party websites or platforms</strong>. We are
                            <strong>not responsible</strong> for the privacy or security of such sites. Please review
                            their own privacy policies before providing personal information.
                        </p>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getPrivacyPolicyList } from '@/api/komo'
export default {
    data () {
        return {
            privacyPolicyList: [],
            loading: true // 添加加载状态
        }
    },
    async created () {
        await this.initData();
    },
    methods: {
        async initData () {
            try {
                this.loading = true; // 开始加载
                const list = await getPrivacyPolicyList(localStorage.getItem('pageId'));
                // 如果返回的是对象，将其转换为数组
                if (list?.data?.info && typeof list.data.info === 'object' && !Array.isArray(list.data.info)) {
                    this.privacyPolicyList = Object.values(list.data.info);
                } else if (Array.isArray(list?.data?.info)) {
                    this.privacyPolicyList = list.data.info;
                }
            } catch (error) {
                console.error('数据加载失败:', error);
            } finally {
                this.loading = false; // 加载完成
            }
        }
    }
}
</script>
<style scoped lang="scss">
.privacy {
    padding: var(--nav-max-height) 0 0;
    display: block;
    color: var(--font-color);
}

.privacy-cont {
    display: block;
    padding: 0;
}

.privacy-section {
    width: 100%;
}

.privacy-section-container {
    max-width: 65ch;
    margin: 0 auto;
    padding-left: 20px;
    padding-right: 20px;
}

.privacy-section-container-title {
    text-align: center;
    margin: 30px 0 15px;
}

.privacy-section-container-title h1 {
    letter-spacing: -0.01em;
}

.privacy-section-container-body {
    margin-bottom: 30px;
}

::v-deep(h1) {
    width: 100%;
    text-align: center;
    display: inline-block;
    position: relative;
    margin-bottom: 15px;
    font-size: var(--h1-size);
    color: var(--font-color);
}

::v-deep(h2) {
    width: 100%;
    text-align: left;
    display: inline-block;
    position: relative;
    margin-bottom: 15px;
    font-size: var(--h2-size);
    color: var(--font-color);
    margin-top: 1em;
}

::v-deep(p) {
    margin: 0 0 15px 0;
    font-size: var(--base-font-size);
    line-height: 1.6;
    color: var(--font-color);
    font-family: var(--body-font-stack);
    font-weight: var(--body-font-weight);
    font-style: var(--body-font-style);
    -webkit-font-smoothing: antialiased;
    -webkit-text-size-adjust: 100%;
}

// 在现有样式中添加以下内容
.loading-placeholder {
    .skeleton-title {
        width: 60%;
        height: 32px;
        background: #f0f0f0;
        margin: 30px auto 40px;
        border-radius: 4px;
        animation: skeleton-loading 1.5s infinite;
    }

    .skeleton-content {
        margin-bottom: 30px;
    }

    .skeleton-subtitle {
        width: 40%;
        height: 24px;
        background: #f0f0f0;
        margin-bottom: 15px;
        border-radius: 4px;
        animation: skeleton-loading 1.5s infinite;
    }

    .skeleton-text {
        width: 100%;
        height: 16px;
        background: #f0f0f0;
        margin-bottom: 10px;
        border-radius: 4px;
        animation: skeleton-loading 1.5s infinite;
    }

    .skeleton-text:nth-child(2) {
        width: 90%;
    }

    .skeleton-text:nth-child(3) {
        width: 95%;
    }
}

@keyframes skeleton-loading {
    0% {
        background-color: #f0f0f0;
    }

    50% {
        background-color: #e0e0e0;
    }

    100% {
        background-color: #f0f0f0;
    }
}

@media only screen and (min-width: 481px) {
    .privacy-section-container-title {
        margin: 100px 0;
    }
}

@media (max-width: 1115px) {
    .privacy {
        padding: var(--nav-1115-height) 0 0;
    }
}

@media (max-width: 990px) {
    .privacy {
        padding: var(--nav-990-height) 0 0;
    }
}
</style>